export const CONTENT_SERVER_ROOT_URL = '/content'
export const CONTENT_SERVER_ENDPOINTS = {
  LOG: '/log',
}
